import React from 'react'
import $ from "jquery";

import { Helmet } from "react-helmet";

import RelatedProduct from '../components/Product'

import { getImageUrl, Sizes } from '../components/blocks/editable/Img'
import ShareModal from '../components/modal/ShareModal'
import ProductSettingsModal from '../components/modal/ProductSettingsModal'

import General from '../utils/General'
import ScriptCache from '../utils/ScriptCache'
import Currency from '../utils/Currency'
import Notify from '../utils/Notify'
import Cart from '../utils/Cart'

import MockData from "../utils/MockData";
import Event from "../utils/Event";
import Backend from "../utils/Backend";

export default class Product extends React.Component {
  constructor(props){
    super(props)

    let productSlug = window.location.pathname.split("/").pop()

    // key is incremented as the slider js functions
    // overwrite the html so we want to refresh it
    // as React is out of sync when
    // adding/editing/deleting the images
    this.state = {
      key: 0,
      loading: true,
      quantity: 1,
      variant: [],
      customMessage: [],
      editable: props.editable,
      website: window.CURRENT_WEBSITE,
      options: [],
      productSlug,
      campaignProductId: General.getUrlParameter("campaignProductId"),
      dropdown: General.getUrlParameter("dropdown"),
      showProductSettingsModal : false,
      indexLoaded: false,
      purchaseOption: "single",
      frequency: null
    }

    this.quantityInput = React.createRef()

    this._updateWebsite = General.debounce(
      () => {
        Backend.updateWebsite({
          slug: this.state.website.slug,
          extra: this.state.website.extra,
          checkout_type: this.state.website.checkout_type,
        });
      },
      1000,
      false
    );
  }

  componentDidMount() {
    this._setup()
    if (this.state.editable) {
      Backend.getPages(window.CURRENT_WEBSITE_ID);
      Backend.getCCPages();
    }
    Event.on('WEBSITE_UPDATED', () => {
      this.setState({
        website: window.CURRENT_WEBSITE
      })
    });
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  componentWillUnmount(){
    Event.off('WEBSITE_UPDATED');
  }

  _setup(){
    let {
      productSlug
    } = this.state

    this.setState({loading: true})
    Backend.getProducts(productSlug).then(products => {
      let product = products[0]
      let variant = Cart.selectDefaultVariant(product)
      let variantOptions = Cart.getOptions(product)
      let customMessageOptions = Cart.getCustomMessageOptions(product)
      if(product.recurringProductId){
        Backend.getProducts(product.recurringProductId).then(subscribeAndSaveProducts => {
          let subscribeAndSaveProduct = subscribeAndSaveProducts[0]
          this.setState({customMessageOptions, variant, variantOptions, product, loading: false, subscribeAndSaveProduct}, () => this._loadJs())
        })
      }else{
        this.setState({customMessageOptions, variant, variantOptions, product, loading: false}, () => this._loadJs())
      }
    }).catch(e => {
      Notify.error(e.message)
      this.setState({loading: false})
    })
  }

  _loadJs(){
    ScriptCache.loadDefaults()
    setTimeout(() => {
      General.updateAll()
    }, 500)
    this._mobileAddToCartStickyBtn();
  }

  _update(website, callback) {
    this.setState({ website }, () => {
      if (callback) {
        callback();
      }
      this._updateWebsite();
    });
  }

  _mobileAddToCartStickyBtn(){
    try {
      setTimeout(() => {
        var elementButton = $('.m-fixed-btn-addtocart');
        var elementLiveChat = $('div.live-chat.main-container .live-chat-icon');
        // checks the window is less than 768px
        if (elementButton.length && $(window).width() < 768) {

          var distance = elementButton.offset().top + elementButton.outerHeight();

          $(window).scroll(function () {

            if ($(window).scrollTop() >= distance) {

              if (!elementButton.hasClass("affix")) {
                elementButton.addClass("affix");
              }

              if (elementLiveChat.length && !elementLiveChat.hasClass("up-from-btm")) {
                elementLiveChat.addClass("up-from-btm");
              }

            } else {

              if (elementButton.hasClass("affix")) {
                elementButton.removeClass("affix");
              }

              if (elementLiveChat.length && elementLiveChat.hasClass("up-from-btm")) {
                elementLiveChat.removeClass("up-from-btm");
              }

            }

        });

        }
      }, 1000)
    }
    catch (err) {
        console.error(err.message);
    }
  }

  _handleAddToCart(){
    let {
      variant,
      frequency,
      product,
      purchaseOption,
      subscribeAndSaveProduct,
      quantity,
      customMessage,
      variantOptions,
      customMessageOptions
    } = this.state

    if(variant.length !== Object.entries(variantOptions).length){
      Notify.error("Please select all product options")
      return
    }

    if(customMessage.length !== customMessageOptions.length){
      Notify.error("Please fill out all options")
      return
    }

    if(product.billingCycleType === "ONE_TIME" && product.recurringProductId){
      if(purchaseOption === "recurring" && !frequency && product.subscriptionOptions){
        Notify.error("Please select your desired frequency")
        return
      }
    }

    quantity = parseInt(this.quantityInput.current.value)
    variant = Cart.getVariant(product, variant)

    let cartProduct = product
    if(purchaseOption === "recurring" && product.recurringProductId){
      cartProduct = subscribeAndSaveProduct
    }

    this.props.onAddToCartPressed(cartProduct, variant, customMessage, quantity, frequency)

    this.setState({
      purchaseOption: "single",
      variant: Cart.selectDefaultVariant(product),
      customMessage: [],
      quantity: 1,
      frequency: null
    })
  }

  async _onDashboardClicked() {
    await Backend.savePage();
    window.open(`${window.General.ApplicationUrl}/editfunnel/${window.CURRENT_WEBSITE.funnel_reference_id}`, "_self");
  }

  _renderPrice(product, variant){
    let{
      variantOptions
    } = this.state

    const currency = window.CURRENT_CAMPAIGN?.currencySymbol
    let availableOptionsNo = Object.entries(variantOptions).length

    let price = product.cycle1_price
    if((availableOptionsNo > 0) && (variant.length === availableOptionsNo)){
      variant = Cart.getVariant(product, variant)
      if(variant && variant.price){
        price = variant.price
      }
    }

    if(product.on_sale){
      return (
        <>
          <span className="h4 type--strikethrough m-0 pr-1">{ Currency.symbolFormat(price, currency) }</span>
          <span className="h4 m-0 pr-2">{ Currency.symbolFormat(price, currency) }</span>
        </>
      )
    }

    return (
      <>
        <span className="h4 m-0 pr-2">Price:</span>
        <span className="h4 m-0">{ Currency.symbolFormat(price, currency) }</span>
      </>
    )
  }

  _renderRelatedProducts(product){

    if(product.related_products.length == 0){
      return null
    }

    return (
      <section class="product-blocks pt-4">
        <div class="container">
          <h2>Other Popular Products</h2>
          <div class="row">
            {
              product.related_products.map(relatedProduct => {
                return (
                  <RelatedProduct
                    product={relatedProduct}
                    onAddToCartPressed={(product, variant) => this.props.onAddToCartPressed(relatedProduct, variant)}
                  />
                )
              })
            }
          </div>
        </div>
      </section>
    )
  }

  _renderProductVariants(product){
    let {
      variantOptions
    } = this.state

    return Object.entries(variantOptions).map((key, index) => {
      return this._renderVariant(key, index, key[0].toLowerCase() === 'color')
    })
  }

  _renderVariant(key, index, isColor){
    let {
      website,
      variant,
      variantOptions,
    } = this.state

    if(isColor && !variantOptions.Color){
      return
    }

    let colorStyle = website.extra?.product_page_settings?.color_picker_style || "square"

    let variantKey = `variant${index+1}_style`
    let variantStyle = website.extra?.product_page_settings ? website.extra?.product_page_settings[variantKey] : "btn_horizontal"

    const title = isColor ? 'Color' : General.toTitleCase(key[0]);
    const options = isColor ? variantOptions.Color : key[1];
    const selectType = isColor ? colorStyle : variantStyle;

    return (
      <div
        className={`${isColor ? 'color-swatches' : 'sizes'} my-28px`}
      >
        <h4 className="mb-2">{title}</h4>
        {
          selectType === 'dropdown' ?
            <div className="input-select">
              <select
                value={variant[index]}
                onChange={this.handleVariantChange(index, isColor, key)}
              >
                <option>Select {title}</option>
                {options.map((option, optionIndex) => {
                  return (
                    <option key={optionIndex} value={option}>
                      {General.toTitleCase(option)}
                    </option>
                  )
                })}
              </select>
            </div>
          :
            <div className={`items ${selectType}`}>
              {options.map((option, optionIndex) => {
                return (
                  <div
                    key={optionIndex}
                    className="item input-radio input-radio--innerlabel"
                    title={General.toTitleCase(option)}
                  >
                    <input
                      type="radio"
                      name={isColor ? 'colors' : key[0]}
                      value={option}
                      id={`${isColor ? 'color' : key[0]}-${optionIndex}`}
                      checked={variant[index] === option}
                      onChange={this.handleVariantChange(index, isColor, key)}
                    />
                    <label htmlFor={`${isColor ? 'color' : key[0]}-${optionIndex}`} className={isColor ? '' : 'btn'}>
                      {isColor ? <span className='color' style={{ backgroundColor: option }}></span> : General.toTitleCase(option)}
                      {isColor ? <span className='name'>{General.toTitleCase(option)}</span> : null}
                    </label>
                  </div>
                )
              })}
            </div>
        }
      </div>
    )
  }

  _renderCustomMessage(product){
    let{
      customMessage,
      customMessageOptions
    } = this.state

    if(customMessageOptions.length < 1) return null

    return customMessageOptions.map((customMessageOption, index) => {
      return (
        <div
          className={`my-28px`}
        >
          <h4 className="mb-2">{General.toTitleCase(customMessageOption)}</h4>
          <div>
            <input
              type="text"
              placeholder={General.toTitleCase(customMessageOption)}
              value={customMessage[index]?.split(":")[1] || ""}
              onChange={e => {
                customMessage[index] = `${customMessageOption}:${e.target.value}`
                this.setState({customMessage})
              }}
            />
          </div>
        </div>
      )
    })
  }

  handleVariantChange(index, isColor, key) {
    return (e) => {
      const selectedOptionName = e.target.value;
      const variant = [...this.state.variant];

      if (selectedOptionName === General.toTitleCase(key[0])) {
        variant[index] = null;
      } else {
        variant[index] = selectedOptionName;
      }

      this.setState({ variant }, () => {
        setTimeout(() => {
          General.updateSlides();
          General.updateLazyBackgroundImages();
        }, 50);
      });
    };
  }

  _renderSubScribeSave(){
    let {
      frequency,
      product,
      variant,
      variantOptions,
      purchaseOption,
      subscribeAndSaveProduct
    } = this.state

    const currency = window.CURRENT_CAMPAIGN?.currencySymbol

    if (!product.subscriptionOptions){
      return null
    }

    let availableOptionsNo = Object.entries(variantOptions).length

    let price = product.cycle1_price
    if((availableOptionsNo > 0) && (variant.length === availableOptionsNo)){
      variant = Cart.getVariant(product, variant)
      if(variant && variant.price){
        price = variant.price
      }
    }

    const subscribeAndSaveFrequency = product.subscriptionOptions?.split(",").map(option => {
      return {
        value: option,
        label: General.toTitleCase(option)
      }
    })

    let subscribeAndSavePrice = subscribeAndSaveProduct.cycle1_price

    const discount = Math.abs( (parseFloat(price) - parseFloat(subscribeAndSavePrice)) / (parseFloat(price)) ) * 100

    let ITEMS = [
      {
        value: "single",
        label: "One Time Purchase",
        price: `${Currency.symbolFormat(price, currency)}`
      },
      {
        value: "recurring",
        label: "Subscribe and Save",
        price: `${Currency.symbolFormat(subscribeAndSavePrice, currency)}`,
        discount: parseInt(discount),
        frequency: subscribeAndSaveFrequency
      }
    ]

    return (
      <div className='subscribe-save my-28px'>
        <h4 class="mb-2">Purchase Options</h4>
        {
          ITEMS.map((item,index) => {
            return (
              <div class="item input-radio input-radio--innerlabel">
                <input
                  type="radio"
                  name="subscribe"
                  value={item.value}
                  checked={item.value === purchaseOption}
                  onChange={(e) => {
                    purchaseOption = e.target.value
                    this.setState({purchaseOption})
                  }}
                />
                <label for="radio-1">
                  <div className='t-sec'>
                    <div className='dot'><span></span></div>
                    <div className='name'>
                      {item.label}
                      {item.discount > 0 &&
                        <div className='discount'>Save {item.discount}%</div>
                      }
                    </div>
                    <div className='price'>
                      {item.price}
                    </div>
                  </div>

                  {(item.points || item.frequency) &&
                    <div className='b-sec'>
                      <div className='frequency'>
                        <div className='name'>Frequency:</div>
                        <div className="input-select">
                          <select
                            onChange={e => {
                              frequency = e.target.value
                              this.setState({frequency})
                            }}
                          >
                            <option>Select Frequency</option>
                            {
                              item.frequency?.map(option => (
                                <option value={option.value}>{General.toTitleCase(option.label)}</option>
                              ))
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  }
                </label>
              </div>
            )
          })
        }
      </div>
    )
  }

  _renderProductSettingsButton() {
    let {
      editable
    } = this.state;

    if (!editable) {
      return;
    }

    let className = "btn-fixed-left-container ignore-user-set-font";

    return (
      <div className={className}>

        <div className="d-flex">
          <button
            className="btn"
            title="Back to Funnel"
            onClick={() => this._onDashboardClicked()}
          >
            <span className="btn__text">
              <span className="material-icons">arrow_back_ios_new_outlined</span>
              <span className="slide-text">Back to Funnel</span>
            </span>
          </button>
        </div>

        {/* Starts : Button 01 */}
        <div className="d-flex">
          <a
            className="btn styling-button"
            title="Styling"
            onClick={() => this.setState({ showProductSettingsModal: true })}
          >
            <span className="btn__text">
              <span class="material-icons">brush_outline</span>
              <span class="slide-text">Product Settings</span>
            </span>
          </a>
        </div>
        {/* End : Button 01 */}

      </div>
    );
  }

  _renderMeta(){
    let {
      product,
      website
    } = this.state

    if(product == null){
       return null
    }

    let favIconUrl = website.favicon ? website.favicon.original : "/favicon.ico"

    return (
      <Helmet>
        <title>{`${product.productName} | ${website.name}`}</title>
        <meta name="description" content={ product.productDescription} />
        <meta name="keywords" content={ product.productTags || website.keywords } />
        <link rel="icon" href={ favIconUrl }/>
        <meta property="og:title" content={ product.productName }/>
        <meta property="og:image" content={ product.imageUrl }/>
        <meta property="og:description" content={ product.productDescription }/>
        <meta property="og:type" content="website"/>
        <meta property="og:url" content={ window.location.href }/>
        <meta property="twitter:card" content="summary_large_image"/>
        <meta property="twitter:url" content={ window.location.href }/>
        <meta property="twitter:title" content={ product.productName }/>
        <meta property="twitter:description" content={ product.productDescription }/>
        <meta property="twitter:image" content={ product.imageUrl }/>
      </Helmet>
    )
  }

  _renderSlides(){
    let {
      key,
      variant,
      product,
    } = this.state

    if(product == null){
       return null
    }

    let images = [{original: product.imageUrl}]

    if(product.imageUrls){
      images = product.imageUrls.map(imageUrl => {
        return {original: imageUrl}
      })
    }

    let selectedVariant = Cart.getVariant(product, variant)
    if(selectedVariant?.imageUrl){
      images.unshift({original: selectedVariant.imageUrl})
    }

    return (
      <ul key={images.length} className="slides">
        {
          images.map((image, index) => {
            return (
              <li
                className="lazy-background"
                key={index}
                style={{ backgroundImage: "url(" + getImageUrl(image, "product-page") + ")" }}
                priority={this.props.index}
              ></li>
            )
          })
        }
      </ul>
    )
  }

  _renderLoading(){
    return (
      <div className="main-container page product">
        {/* starts, main product section  */}
        <section className="switchable sticky-sidebars page-product pt-0 pb-4 pt-md-5">
          <div className="container">
            <div className="row justify-content-around">
              {/* starts, column right, sticky sidebar  */}
              <div className="col-md-5">
                <div className="sidebar__inner">
                  <h2 className="shimmer" style={{ height: 41}}/>
                  <div class="shimmer" style={{ width: 100, height: 26}} />
                  <div>
                    <div class="sizes my-28px">
                      <h4 class="shimmer" style={{ width: 50, height: 26}} />
                      <div class="items btn_horizontal">
                        <div class="item shimmer" style={{ width: 84, height: 39}} />
                        <div class="item shimmer" style={{ width: 84, height: 39}} />
                      </div>
                    </div>
                    <div class="my-28px">
                      <h4 class="shimmer" style={{ width: 50, height: 26}} />
                      <div class="shimmer" style={{ height: 45}} />
                    </div>
                    <div class="my-28px">
                      <h4 class="shimmer" style={{ width: 50, height: 26}} />
                      <div class="shimmer" style={{ height: 45}} />
                    </div>
                    <div class="row quan-cart my-38px mx-0">
                      <div class="col-md-4 pl-0">
                        <div class="shimmer" style={{ width: 102, height: 45}} />
                      </div>
                      <div class="col-md-8 p-md-0">
                        <div class="shimmer" style={{ height: 45}} />
                      </div>
                    </div>
                    <span class="link-share block type--fine-print text-center my-38px d-flex justify-content-center align-items-center">
                      <span class="r-box material-icons"><div class="shimmer" style={{ width: 22, height: 22}} /></span>
                      <a href="javascript:void(0)" class="text-uppercase type--underline link--primary">
                        <div class="shimmer" style={{ width: 124, height: 22}} />
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              {/* end, column right, sticky sidebar  */}
              {/* starts, column left  */}
              <div className="col-md-7">
                 {/* starts, slider  */}
                 <div className="shimmer slider-product-main slider border--round boxed--border"/>
                  {/* end, slider  */}
                  <section class="switchable p-0">
                    <div class="container">
                      <div class="row justify-content-between">
                        <div class="col-md-12 col-lg-12 p-0">
                          <h2><div class="shimmer" style={{ height: 45}} /></h2>
                          <div class="lead pre"><div class="shimmer" style={{ height: 135}} /></div>
                        </div>
                      </div>
                    </div>
                  </section>
              </div>
              {/* end, column left  */}
            </div>
          </div>
        </section>
        {/* end, main product section  */}
      </div>
    )
  }

  render(){
    let {
      product,
      website,
      variant,
      quantity,
      funnelJson,
      indexLoaded,
      campaignJson,
      showShareModal,
      variantOptions,
      loading
    } = this.state

    if(loading){
      return (
        <>
          { this._renderLoading() }
        </>
      )
    }

    if(!product || !variantOptions){
      return null
    }

    let availableOptionsNo = Object.entries(variantOptions).length

    let showAddToCart = Cart.showAddToCart(product, variant)
    let stock = parseInt(product.stockQuantity)
    if((availableOptionsNo > 0) && (variant.length === availableOptionsNo)){
      let variantObject = Cart.getVariant(product, variant)
      if(variantObject){
        stock = variantObject.stockQuantity
      }
    }
    let cartButtonText = "Add To Cart"
    if(window.CURRENT_WEBSITE.checkout_type === "instant"){
      cartButtonText = "Buy Now"
    }

    const showSubscribeAndSave = product.billingCycleType === "ONE_TIME" && product.recurringProductId

    return (
      <>
        <div className="main-container page product">
          { this._renderMeta() }
          {/* starts, main product section  */}
          <section className="switchable sticky-sidebars page-product pt-0 pb-4 pt-md-5">
            <div className="container">
              <div className="row justify-content-around">

                {/* starts, column right, sticky sidebar  */}
                <div className="col-md-5">
                  <div className="sidebar__inner">
                    <h2 className='fs-md-30'>{ product.productName }</h2>
                    <div className="text-block d-flex align-items-center mb-0">
                      { this._renderPrice(product, variant) }
                      { product.on_sale &&
                        <span className="label position-static product-sale-price">Sale</span>
                      }
                    </div>
                    <div>
                      { this._renderProductVariants(product) }
                      { this._renderCustomMessage(product) }
                      {
                        showSubscribeAndSave && this._renderSubScribeSave()
                      }
                      <div className='row quan-cart my-38px mx-0'>
                        <div className='col-md-4 pl-0'>
                          <div className="row align-items-center m-0">
                            <div className="col-12 p-0 m-0">
                              <div className="input-number">
                                <input
                                  ref={this.quantityInput}
                                  type="number"
                                  name="quantity"
                                  placeholder="Quantity"
                                  value={ quantity }
                                  min="1"
                                  onChange={e => {
                                    this.setState({
                                      quantity: parseInt(e.target.value)
                                    })
                                  }}
                                />
                                <div className="input-number__controls">
                                  <span
                                    className="input-number__increase"
                                    onClick={() => {
                                      this.setState({
                                        quantity: quantity+1
                                      })
                                    }}
                                  >
                                    <i class="stack-up-open"></i>
                                  </span>
                                  <span
                                    className="input-number__decrease"
                                    onClick={() => {
                                      let value = quantity - 1
                                      if(value <= 0) {
                                        value = 1
                                      }
                                      this.setState({
                                        quantity: value
                                      })
                                    }}
                                  >
                                    <i class="stack-down-open"></i>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='col-md-8 p-md-0'>
                          <a
                            className="btn btn--primary w-100 mb-0 m-fixed-btn-addtocart"
                            onClick={() => this._handleAddToCart()}
                          >
                            <span className="btn__text">
                              {cartButtonText}
                            </span>
                          </a>
                        </div>
                      </div>
                      {/* starts, Share this product  */}
                      <span className="link-share block type--fine-print text-center my-38px d-flex justify-content-center align-items-center">
                        <span className="r-box material-icons bg-c-primary">share</span>
                        <a
                          href='javascript:void(0)'
                          className='text-uppercase type--underline link--primary'
                          onClick={() => {
                            this.setState({ showShareModal: true })
                          }}
                        >
                          Share this Product
                        </a>
                      </span>
                      <ShareModal
                        show={showShareModal}
                        title="Share This Product"
                        message="Copy the link below to share this product"
                        shareTitle="Checkout This Product"
                        url={window.location}
                        onHide={() => this.setState({showShareModal: false})}
                        onAdded={() => this.setState({showShareModal: false})}
                      />
                      {/* end, Share this product  */}

                    </div>
                  </div>
                </div>
                {/* end, column right, sticky sidebar  */}

                {/* starts, column left  */}
                <div className="col-md-7">

                  {/* starts, slider  */}
                  <div
                    className="slider-product-main slider border--round boxed--border"
                    data-paging="true"
                    data-arrows="true"
                  >
                      { this._renderSlides() }
                  </div>
                  <div
                    className="slider-product-nav slider border--round boxed--border"
                    data-asNavFor=".slider-product-main .slides"
                    data-asNavTrue="true"
                  >
                      { this._renderSlides() }
                  </div>
                  {/* end, slider  */}

                  {
                    product.productDescription &&
                    <>
                      {/* starts, Product Description  */}
                      <section className="switchable p-0">
                        <div className="container">
                          <div className="row justify-content-between">
                            <div className="col-md-12 col-lg-12 p-0">
                              <h2>Product Description</h2>
                              <div
                                className="lead pre"
                                dangerouslySetInnerHTML={{
                                  __html: product.productDescription
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </section>
                      {/* end, Product Description  */}
                    </>
                  }

                </div>
                {/* end, column left  */}

              </div>
            </div>
          </section>
          {/* end, main product section  */}

          {/*{ this._renderRelatedProducts(product) }*/}
        </div>
        {this._renderProductSettingsButton()}
        <ProductSettingsModal
          show={this.state.showProductSettingsModal}
          website={website}
          onCheckoutTypeUpdated={(checkoutType) => {
            website.checkout_type = checkoutType
            this._update(website)
          }}
          onUpdated={(data) => {
            if(!website.extra){
              website.extra = {product_page_settings: null}
            }
            website.extra.product_page_settings = data
            this._update(website)
          }}
          onHide={() => this.setState({showProductSettingsModal: false})}
        />
        <div id="notification-container" class="text-center">
          <div id="notification-content"></div>
        </div>
      </>
    )
  }
}
